// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed, fontBold } from "@fdr/static-ui/Typography";
import ButtonDefault from "../../_atoms/ButtonDefault";

export const RunnerRatingContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: ${({ useGraphStatusV2 }) =>
    useGraphStatusV2 ? "12px 0" : "4px 0 12px 0"};
  ${({ hasPastRaces }) =>
    hasPastRaces &&
    css`
      border-bottom: 1px solid ${buildColor("grey", "300")};
      margin-right: 12px;
    `};
`;

export const RattingValue = styled(ButtonDefault)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 78px;
`;

export const RatingDescription = styled.span`
  color: ${({ hasRatingLabel }) =>
    buildColor(hasRatingLabel ? "green" : "blue")};
  font-family: ${fontCondensed};
  font-size: 12px;
  margin-top: ${({ useGraphStatusV2 }) => (useGraphStatusV2 ? "3px" : "-8px")};
  text-transform: uppercase;
`;

export const RatingLabel = styled.span`
  font-family: ${fontBold};
  font-style: italic;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: ${buildColor("green")};
  position: absolute;
  top: 0;
  left: -6px;
`;

export const RatingOnboardingTooltip = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  font-family: ${fontCondensed};
  letter-spacing: 1.03px;
  font-size: 12px;
  text-transform: uppercase;
  background-color: ${buildColor("navy", "500")};
  color: ${buildColor("white", "100")};
  align-items: center;
  padding: 8px;
  z-index: 10;
  top: -38px;
  width: 126px;
  border-radius: 2px;

  &::before {
    position: absolute;
    left: calc(50% - 4px);
    bottom: -4px;
    content: "";
    width: 0;
    height: 0;
    border-width: 4px 4px 0;
    border-color: ${buildColor("navy", "500")} transparent transparent
      transparent;
    border-style: solid;
  }
`;
